import * as Sentry from "@sentry/nextjs";
import {NextPage} from "next";
import {useTranslation} from "@i18n/client";
import React from "react";
import {LeverJobPostingResponse, LightLeverJobPostingResponse} from "src/_services/types";
import {LEVER_URI} from "src/components/_common/_constants";
import Bios from "src/components/v5/About/Bios";
import Careers from "src/components/v5/About/Careers";
import CoreValues from "src/components/v5/About/CoreValues";

import AboutUs from "../components/v5/About/AboutUs";
import Hero from "../components/v5/About/Hero";
import Layout from "../components/v5/Layout";
import {NavTheme} from "../components/v5/Nav/useNavState";
import {withLocaleServerSideProps} from "@i18n/pages";

type Props = {
  jobs: LightLeverJobPostingResponse[];
};

const About: NextPage<Props> = ({jobs = []}) => {
  const i18n = useTranslation();

  return (
    <Layout
      pageTitle={i18n.t("About Us | Carbon Health")}
      pageImage="about-us-mint"
      navTheme={NavTheme.LIGHT}
      wrapClasses="ovf-unset" // required for position sticky to work
    >
      <Hero
        src="/static/img/v5/woman-with-phone.jpg"
        alt={i18n.t("A woman sitting in sunlight smiling at her phone")}
        jobCount={jobs.length}
      />
      <AboutUs />
      <CoreValues />
      <Bios />
      <Careers jobs={jobs} />
    </Layout>
  );
};

export const getServerSideProps = withLocaleServerSideProps<Props>(async () => {
  const jobs = await fetch(LEVER_URI)
    .then(res => res.json())
    .then((jobs: LeverJobPostingResponse[]) => jobs.map(job => ({categories: job.categories})))
    .catch(err => {
      Sentry.captureException(err);
      return [];
    });
  return {props: {jobs}};
});

export default About;
